import axios from 'axios';
import { isTokenExpired } from './tokenTimeCheck';
import {
  getGestifyTokenCookies,
  removeGestifyTokenCookies,
} from './authCookies';
import { API_GESTIFY_AUTH_URL, URL_REFRESH, URL_USER, URL_V1 } from '../utils';

interface ReturnFunction {
  token: string;
  refresh: string;
}

export const fetchRefreshToken = async (
  refreshToken: string,
  extToken?: string,
): Promise<ReturnFunction | null> => {
  const token = extToken ?? (await getGestifyTokenCookies()).gestifyToken;
  axios.defaults.baseURL = API_GESTIFY_AUTH_URL;
  axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
  axios.defaults.headers.post['Content-Type'] = 'application/json';

  try {
    const response = await axios.get(
      `${URL_USER}${URL_V1}${URL_REFRESH}/${refreshToken}`,
    );
    if (response.status === 200) {
      const { access_token, refresh } = response.data;
      return { token: access_token, refresh };
    }
    return null;
  } catch (error: any) {
    return null;
  }
};

export default async function checkTokenValidity(): Promise<string | null> {
  const { gestifyToken } = await getGestifyTokenCookies();
  const isExpired = await isTokenExpired(gestifyToken);

  if (!isExpired) {
    return gestifyToken;
  }
  await removeGestifyTokenCookies();
  return null;
}
